import React from 'react';
import { UIHeading2 } from '@cian/ui-kit/typography';
import { Link } from '../Link';
import { IReview } from '../Reviews';
import styles from './ReviewItem.css';

type TReviewItemProps = IReview;

export const ReviewItem: React.FC<TReviewItemProps> = ({ title, imageUrl, url }) => {
  return (
    <Link href={url} className={styles['link']}>
      <div
        className={styles['image']}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      ></div>
      <div className={styles['content']}>
        <UIHeading2 color="white_100">{title}</UIHeading2>
      </div>
    </Link>
  );
};
